// Shared display name for a wallet receiving address, used by every screen that
// lists addresses (coin detail, address selector) so they never disagree.
//
// - A genuinely custom label wins.
// - Auto-generated "Wallet N" labels persisted by an earlier bug are ignored.
// - Otherwise the name keys on the stable derivationIndex (unique per chain), so
//   it stays correct when addresses are added/removed.

export function addressDisplayName(
  a: { label: string | null; derivationIndex: number },
  walletWord: string,
): string {
  const pattern = new RegExp(`^${walletWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s+\\d+$`);
  if (a.label && !pattern.test(a.label.trim())) return a.label;
  return `${walletWord} ${a.derivationIndex + 1}`;
}

/** Truncated address shown across the app (coin detail, pay-from): 6 + … + 4. */
export const shortenAddress = (a: string): string =>
  a.length > 14 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a;
